import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiArticles = () => {
 const { auth } = contextApp();

 const ArticleApi = axios.create({
  baseURL: urls.articles(),
  headers: { 'x-access-token': auth?.token }
 });

 const getArticle = async ({ queryKey }) => {
  const [, code, params = {}] = queryKey;
  return (await ArticleApi.get(`/${code}`, { params })).data;
 };

 const getArticles = async ({ queryKey }) => {
  const [, params = {}] = queryKey;
  return (await ArticleApi.get('/', { params })).data;
 };

 const getArticleNames = async ({ queryKey }) => {
  const [, params = {}] = queryKey;
  return (await ArticleApi.get('/names', { params })).data;
 };

 const createArticle = async ({ data }) =>
  (await ArticleApi.post('/', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data;

 const updateArticle = async ({ code, data }) =>
  (await ArticleApi.put('/' + code, data, { headers: { 'Content-Type': 'multipart/form-data' } })).data;

 return { getArticle, getArticles, getArticleNames, createArticle, updateArticle };
};

export default { useApiArticles };
